/** File Packet overlay — office fields only. Checklists, messages, and calendar stay in their modules. */

export const FILE_PACKET_KEY = "dh_file_packets";

export const FILE_STATUSES = [
  { id: "active", label: "Active" },
  { id: "pending", label: "Pending" },
  { id: "escrow", label: "Escrow" },
  { id: "inspection", label: "Inspection" },
  { id: "appraisal", label: "Appraisal" },
  { id: "custom", label: "Custom" },
  { id: "closed", label: "Closed" },
  { id: "dissolved", label: "Dissolved" },
];

export const STEP_STATUSES = [
  { id: "not_started", label: "Not started" },
  { id: "in_progress", label: "In progress" },
  { id: "completed", label: "Completed" },
];

export const LIFECYCLE_STAGES = [
  { id: "initial_contact", title: "Initial Contact", detail: "First conversation and how this client arrived." },
  { id: "agreement_signed", title: "Agreement Signed", detail: "Buyer representation or listing agreement on file." },
  { id: "escrow_opened", title: "Escrow Opened", detail: "Earnest money in and clocks running." },
  { id: "inspections", title: "Inspections", detail: "General and specialist inspections." },
  { id: "appraisal", title: "Appraisal", detail: "Lender or cash appraisal path." },
  { id: "title", title: "Title", detail: "Title search, exceptions, and clearance." },
  { id: "custom_steps", title: "Custom Steps", detail: "Office-added work unique to this file." },
  { id: "final_walkthrough", title: "Final Walkthrough", detail: "Condition check before close." },
  { id: "close_or_dissolution", title: "Close or Dissolution", detail: "Closed, cancelled, or walked." },
];

/** Seller office equivalents of the buyer Handy Transaction Checklist — File Packet only. */
export const SELLER_TRANSACTION_ITEMS = [
  {
    id: "listing-consult",
    title: "Listing consultation",
    detail: "Walk the home, hear the seller’s goals, and set a listing path.",
  },
  {
    id: "listing-agreement",
    title: "Listing agreement",
    detail: "Representation signed, term and compensation understood.",
  },
  {
    id: "pricing",
    title: "Pricing / CMA",
    detail: "Comps, net sheet, and list-price conversation.",
  },
  {
    id: "marketing",
    title: "Marketing / showings",
    detail: "Photos, remarks, and showing access in motion.",
  },
  {
    id: "offer-review",
    title: "Offer review",
    detail: "Compare terms, not only price. Decide accept, counter, or wait.",
  },
  {
    id: "seller-inspections",
    title: "Inspections / repairs",
    detail: "Buyer inspections, repair asks, credits, or as-is.",
  },
  {
    id: "seller-appraisal",
    title: "Appraisal",
    detail: "Value support and any gap conversation.",
  },
  {
    id: "seller-closing",
    title: "Closing",
    detail: "Signing, funds, and possession timing.",
  },
  {
    id: "possession",
    title: "Possession / keys",
    detail: "Keys, remotes, codes, and walk-away condition.",
  },
];

export const FILE_SECTIONS = [
  { id: "profile", label: "Profile" },
  { id: "checklist", label: "Checklist" },
  { id: "timeline", label: "Timeline" },
  { id: "messages", label: "Messages" },
  { id: "calendar", label: "Calendar" },
  { id: "pdf", label: "PDF" },
];

export function fileStatusLabel(id) {
  return FILE_STATUSES.find((item) => item.id === id)?.label || id || "";
}

export function stepStatusLabel(id) {
  return STEP_STATUSES.find((item) => item.id === id)?.label || id || "Not started";
}
